$("a[href='#']").click(function (e) { e.preventDefault(); });

$(document).on('click', '.toggleMobileMenu', function(){
    if($('.mobile_menu_wrap').hasClass('invisible')){
        $('.mobile_menu_wrap').removeClass('invisible');
        $('.mobile_menu_wrap').removeClass('opacity-0');
        $('.mobile_menu_inner_wrap').removeClass('-left-full');

        $('.mobile_menu_wrap').addClass('visible');
        $('.mobile_menu_wrap').addClass('opacity-100');
        $('.mobile_menu_inner_wrap').addClass('left-0');
    }else{
        $('.mobile_menu_wrap').addClass('invisible');
        $('.mobile_menu_wrap').addClass('opacity-0');
        $('.mobile_menu_inner_wrap').removeClass('left-0');

        $('.mobile_menu_wrap').removeClass('visible');
        $('.mobile_menu_wrap').removeClass('opacity-100');
        $('.mobile_menu_inner_wrap').addClass('-left-full');
    }
});

// function mobileMenuExpand(menu_id){
//     let el = document.getElementById(menu_id);
//     let el_btn = document.getElementById('btn_' + menu_id);

//     if(el.classList.contains('active')){
//         el.classList.remove('super_active');
//         el.classList.remove('active');
//         el_btn.classList.remove('active');
//     }else{
//         el.classList.add('active');
//         el_btn.classList.add('active');

//         setTimeout(() => {
//         el.classList.add('super_active');
//         }, 300);
//     }
// }


$(document).on('click', '.side_menu_btn', function(){
    let menu_id = $(this).data('id');

    let el = $('#' + menu_id);
    let el_btn = $('#btn_' + menu_id);

    if(el_btn.hasClass('active')){
        el.removeClass('super_active');
        el.removeClass('active');
        el_btn.removeClass('active');
    }else{
        el.addClass('active');
        el_btn.addClass('active');

        setTimeout(() => {
            el.addClass('super_active');
        }, 300);
    }
});
$(document).on('click', '.tab_items li.tab_single_item', function(){
    let target_id = $(this).data('targetid');

    $('.tab_item_images a').hide();
    $('.tab_item_images a#tab_item_' + target_id).show();

    $('.tab_single_item').removeClass('active');
    $(this).addClass('active');
});

$('.question').click(function() {
    $('.answer').not($(this).next('.answer')).slideUp(300);

    $(this).next('.answer').slideToggle(300);
});
